import './app.css'

function App() {
  return (
    <div className='app'>
      <div>
        <img
          className='logo'
          alt='logo for motogx.com'
          src='https://static.motogx.com/motogx-logo-zomg.svg'
        />
        <h1>Coming Soon</h1>
      </div>
    </div>
  )
}

export default App
